import { render, staticRenderFns } from "./CollapserSection.vue?vue&type=template&id=78c5ebfe&scoped=true&"
import script from "./CollapserSection.vue?vue&type=script&lang=js&"
export * from "./CollapserSection.vue?vue&type=script&lang=js&"
import style0 from "./CollapserSection.vue?vue&type=style&index=0&id=78c5ebfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c5ebfe",
  null
  
)

export default component.exports